import LunchDiningIcon from "@mui/icons-material/LunchDining";
import FmbThaliList from "./FmbThaliList";

export default {
  list: FmbThaliList,
  icon: LunchDiningIcon,
  label: "Thali",
  options: { label: "Thali" },
  name: "fmbThali",
};
